// import "babel-polyfill"
// import 'core-js/stable';
// import 'regenerator-runtime/runtime';
import "./public-path";
import Vue from "vue";
import DOMPurify from "dompurify";

function setSafeHtml(el, value) {
  el.innerHTML = DOMPurify.sanitize(value == null ? "" : String(value), {
    ADD_ATTR: ["target"],
  });
}

Vue.directive("safe-html", {
  bind(el, binding) {
    setSafeHtml(el, binding.value);
  },
  update(el, binding) {
    if (binding.value !== binding.oldValue) {
      setSafeHtml(el, binding.value);
    }
  },
});

// 修复 Qiankun 下 element-ui dropdown/popper 的 getComputedStyle 报错
if (window.__POWERED_BY_QIANKUN__) {
  const originalGetComputedStyle = window.getComputedStyle;
  const dummyElement = document.createElement("div");
  window.getComputedStyle = function (el, pseudoElt) {
    if (!el || el.nodeType !== 1) {
      return originalGetComputedStyle.call(window, dummyElement, pseudoElt);
    }
    return originalGetComputedStyle.call(window, el, pseudoElt);
  };
}

// 修复 Chrome 119+ 中 element-ui 弹窗隐藏时触发的 aria-hidden 报错
const originalSetAttribute = Element.prototype.setAttribute;
Element.prototype.setAttribute = function (name, value) {
  if (name === "aria-hidden" && value === "true") {
    // 如果设置 aria-hidden="true"，并且焦点在自身或子元素上，移除焦点避免浏览器报错
    if (this === document.activeElement || this.contains(document.activeElement)) {
      document.activeElement.blur();
    }
  }
  return originalSetAttribute.call(this, name, value);
};

import App from "./App.vue";
import router from "./router";
import store from "./store";
import Button from "element-ui/lib/button";
import Checkbox from "element-ui/lib/checkbox";
import CheckboxGroup from "element-ui/lib/checkbox-group";
import DatePicker from "element-ui/lib/date-picker";
import Dialog from "element-ui/lib/dialog";
import Empty from "element-ui/lib/empty";
import Form from "element-ui/lib/form";
import FormItem from "element-ui/lib/form-item";
import Input from "element-ui/lib/input";
import Loading from "element-ui/lib/loading";
import Menu from "element-ui/lib/menu";
import MenuItem from "element-ui/lib/menu-item";
import Message from "element-ui/lib/message";
import MessageBox from "element-ui/lib/message-box";
import Notification from "element-ui/lib/notification";
import Option from "element-ui/lib/option";
import Pagination from "element-ui/lib/pagination";
import Popover from "element-ui/lib/popover";
import Progress from "element-ui/lib/progress";
import Select from "element-ui/lib/select";
import Slider from "element-ui/lib/slider";
import Submenu from "element-ui/lib/submenu";
import Switch from "element-ui/lib/switch";
import Table from "element-ui/lib/table";
import TableColumn from "element-ui/lib/table-column";
import TabPane from "element-ui/lib/tab-pane";
import Tabs from "element-ui/lib/tabs";
import Timeline from "element-ui/lib/timeline";
import TimelineItem from "element-ui/lib/timeline-item";
import Tooltip from "element-ui/lib/tooltip";
import Tree from "element-ui/lib/tree";
import Upload from "element-ui/lib/upload";
import "./styles/reset.scss";
import "./styles/init.scss";
import "./styles/_variables.scss";
import "element-ui/lib/theme-chalk/index.css";
import "../element-variables.scss";

import "./assets/fonts/iconfont.css";
// 引入swiper样式
import "swiper/dist/css/swiper.css";

import fetch from "./api/axios";
import axios from "axios";
import baseurl from "./api/baseurl.js";

const axiosInstance = axios.create({
  baseURL: baseurl.baseUrl,
});

import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);

[
  Button,
  Checkbox,
  CheckboxGroup,
  DatePicker,
  Dialog,
  Empty,
  Form,
  FormItem,
  Input,
  Menu,
  MenuItem,
  Option,
  Pagination,
  Popover,
  Progress,
  Select,
  Slider,
  Submenu,
  Switch,
  Table,
  TableColumn,
  TabPane,
  Tabs,
  Timeline,
  TimelineItem,
  Tooltip,
  Tree,
  Upload,
].forEach(component => Vue.use(component));
Vue.use(Loading.directive);
Vue.prototype.$loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$notify = Notification;
const MESSAGE_DURATION = 3000;

function normalizeMessageOptions(options) {
  if (typeof options === "string") {
    return {
      message: options,
      duration: MESSAGE_DURATION,
    };
  }
  return {
    ...options,
    duration: options && options.duration !== undefined ? options.duration : MESSAGE_DURATION,
  };
}

const wrappedMessage = options => Message(normalizeMessageOptions(options));
["success", "warning", "info", "error"].forEach(type => {
  wrappedMessage[type] = options => Message[type](normalizeMessageOptions(options));
});
Vue.prototype.$message = wrappedMessage;

Vue.prototype.$http = fetch;
Vue.config.productionTip = false;

import { globalUrl } from "./api/upload.js";
Vue.prototype.globalUrl = globalUrl;
Vue.prototype.$loginReady = false;

Vue.prototype.capitalize = function (value) {
  if (!value) return "";
  value = value.toString();
  if (value.length > 290) {
    return value.substr(0, 290) + "...";
  } else {
    return value;
  }
};

let instance = null;

async function checkIPUserAndAutoLogin() {
  if (window.__CHONGDA_LOGIN_CHECK_PROMISE__) {
    return window.__CHONGDA_LOGIN_CHECK_PROMISE__;
  }
  const token = localStorage.getItem("jyx_token");
  if (token) {
    return true;
  }

  window.__CHONGDA_LOGIN_CHECK_PROMISE__ = (async () => {
    try {
      const ipRes = await axiosInstance.get("/api/v1/plug/getIpUser", { timeout: 5000 });
      if (ipRes.data && ipRes.data.code == 200 && ipRes.data.data && ipRes.data.data.userName) {
        const userName = ipRes.data.data.userName;
        const password = ipRes.data.data.password;
        const loginRes = await axiosInstance.post("/api/v1/login", { username: userName, password: password });
        if (loginRes.data && loginRes.data.code == 200) {
          localStorage.setItem("jyx_token", loginRes.data.token);
          localStorage.setItem("userName", userName);
          return true;
        }
      }
      return false;
    } catch (error) {
      // 这里即使接口报错（Failed to fetch / 网络错误），也应该直接返回 false 放行，不要抛出异常中断 Qiankun 挂载
      return false;
    } finally {
      window.__CHONGDA_LOGIN_CHECK_PROMISE__ = null;
    }
  })();
  return window.__CHONGDA_LOGIN_CHECK_PROMISE__;
}

async function hydrateTokenFromHost(props = {}) {
  if (!window.__POWERED_BY_QIANKUN__) {
    return;
  }

  if (typeof props.getMicroToken === "function") {
    const token = props.getMicroToken();
    if (token) {
      localStorage.setItem("jyx_token", token);
      return;
    }
  }

  if (typeof props.refreshMicroToken === "function" && localStorage.getItem("ip_user") != 1) {
    try {
      await props.refreshMicroToken();
    } catch (error) {
      // 继续走子应用自己的兜底登录流程。
    }
  }

  if (typeof props.getMicroToken === "function") {
    const token = props.getMicroToken();
    if (token) {
      localStorage.setItem("jyx_token", token);
    }
  }
}

function render(props = {}) {
  const { container } = props;
  instance = new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount(container ? container.querySelector("#app") : "#app");
}

if (!window.__POWERED_BY_QIANKUN__) {
  render();
}

export async function bootstrap() {
  console.log("[vue] chongda_web bootstraped");
}

export async function mount(props) {
  await hydrateTokenFromHost(props);
  await checkIPUserAndAutoLogin();

  const routePath = typeof props.getInitialRoute === "function" ? props.getInitialRoute() : window.location.pathname;
  if (window.__POWERED_BY_QIANKUN__ && routePath && routePath !== router.currentRoute.path) {
    router.push(routePath).catch(() => {});
  }
  render(props);
}

export async function unmount() {
  console.log("[vue] chongda_web unmount");
  if (instance) {
    instance.$destroy();
    instance.$el.innerHTML = "";
    instance = null;
  }
}
